import { types } from "mobx-state-tree";
import type { Instance, SnapshotIn, SnapshotOut } from "mobx-state-tree";

export interface UserInstance extends Instance<typeof User> {}
export interface UserSnapshotIn extends SnapshotIn<typeof User> {}
export interface UserSnapshotOut extends SnapshotOut<typeof User> {}

// User model
export const User = types
  .model("User", {
    id: types.identifier,
    firstName: types.string,
    lastName: types.string,
    city: types.string,
    email: types.maybeNull(types.string), // in rare cases with existing users, email can be null or undefined
    personalNumber: types.string,
    phoneNumber: types.string,
    streetAddress: types.string,
    zipCode: types.string,
    countryCode: types.maybeNull(types.string),
  })
  .views((self) => ({
    get fullName() {
      return `${self.firstName} ${self.lastName}`;
    },

    get fullAddress() {
      return `${self.streetAddress ?? ""}, ${self.zipCode ?? ""} ${
        self.city ?? ""
      }`;
    },
  }));
